module.exports = __webpack_public_path__ + "static/media/RoundedRect_Green.333cfebb.png";